module.exports = __webpack_public_path__ + "img/menu.50fbc22b.svg";